import React, { useState } from 'react';
import { StyledFormControl } from '../../../components/modal-form/styles';

interface Props {
  entidade: any;
  handleInputChange: (campo: string, valor: string | number | boolean) => void;
  // Campo que guarda o total da janela (kmMaximo no excesso, kmMinimo na inatividade).
  campoTotal: string;
}

const arred = (n: number) => Math.round(n * 10) / 10;

// Campo derivado: exibe total / janelaDias e, ao ser editado, grava o total
// equivalente no campo alvo. Nada é persistido além do próprio total.
const KmMediaDiaInput: React.FC<Props> = ({ entidade, handleInputChange, campoTotal }) => {
  const janela = Number(entidade?.janelaDias) || 0;
  const total = Number(entidade?.[campoTotal]) || 0;

  const [editando, setEditando] = useState(false);
  const [texto, setTexto] = useState('');

  const derivado = janela > 0 && total > 0 ? String(arred(total / janela)) : '';

  const aoDigitar = (valor: string) => {
    setTexto(valor);
    const n = Number(valor.replace(',', '.'));
    if (n > 0 && janela > 0) handleInputChange(campoTotal, arred(n * janela));
  };

  return (
    <StyledFormControl
      type="number"
      min={0}
      step={0.1}
      value={editando ? texto : derivado}
      disabled={janela <= 0}
      title={janela <= 0 ? 'Informe a janela de dias primeiro' : undefined}
      onFocus={() => { setEditando(true); setTexto(derivado); }}
      onBlur={() => setEditando(false)}
      onChange={(e: any) => aoDigitar(e.target.value)}
    />
  );
};

export default KmMediaDiaInput;
